import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { getCurrentSlice } from 'utils';
import { categories } from './categories';
import { FilterSubCategoryList, FilterCategoryItem } from './components';

export const ContentCategoryFilter = (props) => {
  const { componentName, parentPlatform, className } = props;
  const dispatch = useDispatch();
  const [showSubCategory, setShowSubCategory] = useState({});
  const filter = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { setSelectedCategories } = getCurrentSlice(reducerName);

  const handleCategoryChange = (event, categoryKey) => {
    const { checked } = event.target;
    dispatch(
      setSelectedCategories({
        categoryKey,
        isChecked: checked,
        subCategories: categories[categoryKey],
        componentName,
        parentPlatform,
      })
    );
  };

  const handleSubCategoryChange = (event, categoryKey) => {
    const { name, checked } = event.target;

    dispatch(
      setSelectedCategories({
        categoryKey,
        isChecked: checked,
        subCategories: [name],
        componentName,
        parentPlatform,
      })
    );
  };

  const handleCategoryClick = (category) => {
    setShowSubCategory({
      ...showSubCategory,
      [category]: !showSubCategory[category],
    });
  };

  return (
    <div className={classNames('filter-content-category', className)}>
      {Object.entries(categories).map(([category, subCategories]) => {
        const hasSelectedSubCategory = filter.selectedCategories[
          category
        ]?.some((selectedSubCategory) =>
          categories[category].includes(selectedSubCategory)
        );
        return (
          <div key={category}>
            <FilterCategoryItem
              category={category}
              hasSelectedSubCategory={hasSelectedSubCategory}
              showSubCategory={showSubCategory}
              onCategoryChange={handleCategoryChange}
              onCategoryClick={handleCategoryClick}
              disabled={filter?.isDisabled}
            />
            {(parentPlatform || showSubCategory[category]) && (
              <FilterSubCategoryList
                category={category}
                subCategories={subCategories}
                selectedCategories={filter.selectedCategories}
                onSubCategoryChange={handleSubCategoryChange}
                disabled={filter?.isDisabled}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

ContentCategoryFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
